import { MedosClient } from "../client/MedosClient";
const WorkspaceService = {
    async fetchWorkspace() {
        try {
            const client = await MedosClient.ensureInitialized();
            const res = await client.get("/workspaces");
            if (!res.data || typeof res.data.workspaceId !== "number") {
                throw new Error("Invalid workspace response");
            }
            return res.data;
        }
        catch (error) {
            throw new Error(`Failed to fetch workspace: ${error.message}`);
        }
    },
    async fetchTheme() {
        try {
            const workspace = await this.fetchWorkspace();
            return workspace.theme;
        }
        catch (error) {
            throw new Error(`Failed to fetch workspace theme: ${error.message}`);
        }
    },
};
export { WorkspaceService };
